/**
 * @generated SignedSource<<2aaad0b2e1005aa31f5e1b5f15cc9a97>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* eslint-disable */

'use strict';

var node = (function(){
var v0 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "User",
    "kind": "LinkedField",
    "name": "user",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "id",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "sponsorCode",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "ProfileSponsorCodeScreenQuery",
    "selections": (v0/*: any*/),
    "type": "ClientAppQuery",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "ProfileSponsorCodeScreenQuery",
    "selections": (v0/*: any*/)
  },
  "params": {
    "cacheID": "8eabf91cf405bb20890996e2bf0400fa",
    "id": null,
    "metadata": {},
    "name": "ProfileSponsorCodeScreenQuery",
    "operationKind": "query",
    "text": "query ProfileSponsorCodeScreenQuery {\n  user {\n    id\n    sponsorCode\n  }\n}\n"
  }
};
})();

node.hash = "3064c840e8333384fc3715927fe398ec";

module.exports = node;
